import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SubmitPricingRecommendationActionsDocument = gql`
  mutation SubmitPricingRecommendationActions(
    $actions: [PricingRecommendationActionInput!]!
  ) {
    submitPricingRecommendationActionsForBusinessOrganization(
      actions: $actions
    ) {
      accepted_count
      alerts_by_supplier {
        alert {
          alert_level
          alert_message
          deleted_draft_update_ids
        }
        supplier_id
      }
      rejected_count
    }
  }
`;
export type SubmitPricingRecommendationActionsMutationFn =
  Apollo.MutationFunction<
    Types.SubmitPricingRecommendationActionsMutation,
    Types.SubmitPricingRecommendationActionsMutationVariables
  >;
export function useSubmitPricingRecommendationActionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SubmitPricingRecommendationActionsMutation,
    Types.SubmitPricingRecommendationActionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SubmitPricingRecommendationActionsMutation,
    Types.SubmitPricingRecommendationActionsMutationVariables
  >(SubmitPricingRecommendationActionsDocument, options);
}
export type SubmitPricingRecommendationActionsMutationHookResult = ReturnType<
  typeof useSubmitPricingRecommendationActionsMutation
>;
export type SubmitPricingRecommendationActionsMutationResult =
  Apollo.MutationResult<Types.SubmitPricingRecommendationActionsMutation>;
export type SubmitPricingRecommendationActionsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SubmitPricingRecommendationActionsMutation,
    Types.SubmitPricingRecommendationActionsMutationVariables
  >;
